module.exports = __webpack_public_path__ + "img/13.75fc7f57.png";